(function () {
  // ===== Diccionario =====
  const DICT = {
    en: {
      familia: {
        "cafes-de-origen": "Single Origin Coffees",
        "cafes-de-especialidad": "Specialty Coffees",
        "cafes-de-autor": "Signature Coffees",
        "cafe-ecologico": "Organic Coffee",
      },
      metodo: {
        espresso: "Espresso",
        moccamaster: "Moccamaster",
        "prensa-francesa": "French press",
        aeropress: "AeroPress",
        v60: "V60",
        "moka-italiana": "Moka / Stovetop",
        "cold-brew": "Cold brew",
      },
      tuestes: { claro: "Light", medio: "Medium", oscuro: "Dark" },
      molidos: {
        "en-grano": "Whole bean",
        fino: "Fine",
        medio: "Medium",
        grueso: "Coarse",
      },
      pais: {
        bali: "Bali",
        brasil: "Brazil",
        burundi: "Burundi",
        colombia: "Colombia",
        etiopia: "Ethiopia",
        guatemala: "Guatemala",
        honduras: "Honduras",
        indonesia: "Indonesia",
        kenia: "Kenya",
        malaui: "Malawi",
        nicaragua: "Nicaragua",
        "papua-nueva-guinea": "Papua New Guinea",
        peru: "Peru",
        "republica-democratica-del-congo":
          "Democratic Republic of the Congo",
        ruanda: "Rwanda",
        tanzania: "Tanzania",
        uganda: "Uganda",
        zambia: "Zambia",
      },
    },
    fr: {
      familia: {
        "cafes-de-origen": "Café d'origine unique",
        "cafes-de-especialidad": "Café de spécialité",
        "cafes-de-autor": "Café signature",
        "cafe-ecologico": "Café biologique",
      },
      metodo: {
        espresso: "Expresso",
        moccamaster: "Moccamaster",
        "prensa-francesa": "Presse française",
        aeropress: "AeroPress",
        v60: "V60",
        "moka-italiana": "Moka / Cuisinière",
        "cold-brew": "Cold brew",
      },
      tuestes: { claro: "Léger", medio: "Moyen", oscuro: "Fort" },
      molidos: {
        "en-grano": "Grain entier",
        fino: "Fin",
        medio: "Moyen",
        grueso: "Gros",
      },
      pais: {
        bali: "Bali",
        brasil: "Brésil",
        burundi: "Burundi",
        colombia: "Colombie",
        etiopia: "Éthiopie",
        guatemala: "Guatemala",
        honduras: "Honduras",
        indonesia: "Indonésie",
        kenia: "Kenya",
        malaui: "Malawi",
        nicaragua: "Nicaragua",
        "papua-nueva-guinea": "Papouasie-Nouvelle-Guinée",
        peru: "Pérou",
        "republica-democratica-del-congo":
          "République démocratique du Congo",
        ruanda: "Rwanda",
        tanzania: "Tanzanie",
        uganda: "Ouganda",
        zambia: "Zambie",
      },
    },
  };

  // ===== Utils =====
  function getLang() {
    const path = location.pathname;
    if (path.startsWith("/en/")) return "en";
    if (path.startsWith("/fr/")) return "fr";
    const htmlLang = (document.documentElement.lang || "").toLowerCase();
    if (htmlLang.startsWith("en")) return "en";
    if (htmlLang.startsWith("fr")) return "fr";
    return "es";
  }

  function handleize(str) {
    return (str || "")
      .toString()
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, "")
      .toLowerCase()
      .trim()
      .replace(/&/g, "-and-")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function scopeFromParamName(pn) {
    if (!pn) return "";
    if (pn.includes("meta.familia")) return "familia";
    if (pn.includes("preparacion.metodo")) return "metodo";
    if (pn.includes("origen.pais")) return "pais";
    if (pn.includes("preparacion.tuestes")) return "tuestes";
    if (pn.includes("preparacion.molidos")) return "molidos";
    return "";
  }

  // ===== Traducción de items del panel (checkboxes) =====
  function translateOneLabel(span, lang) {
    try {
      const label = span.closest("label");
      if (!label) return;

      const input = label.querySelector("input[type=checkbox]");
      const paramName = input ? input.name || "" : "";
      const scope = scopeFromParamName(paramName);
      if (!scope) return;

      // Prioriza input.value (tema lo controla mejor)
      const raw = input && input.value ? input.value : span.textContent;
      const h = handleize(raw);
      const map = DICT[lang] && DICT[lang][scope];
      const tr = map && map[h];
      if (!tr) return;

      if (span.textContent !== tr) span.textContent = tr;

      const li = span.closest("li");
      const tooltip = li && li.querySelector(".m-tooltip__content");
      if (tooltip && tooltip.textContent !== tr) tooltip.textContent = tr;

      const colorName = li && li.querySelector(".m-facet--color-name");
      if (colorName && colorName.firstChild && colorName.firstChild.textContent !== tr) {
        colorName.firstChild.textContent = tr;
      }

      if (input) {
        input.setAttribute("aria-label", tr);
        input.setAttribute("title", tr);
      }
    } catch (e) {}
  }

  // ===== Traducción de chips activos (arriba) =====
  function translateActiveChips(lang) {
    const chips = document.querySelectorAll(
      "#ActiveFacets .m-active-facets--item a > span"
    );
    chips.forEach((wrap) => {
      try {
        // Estructura: <span><span class="m-active-facets--remove-icon">…</span> TEXT_NODE </span>
        const iconSpan = wrap.querySelector(".m-active-facets--remove-icon");
        // El texto suele ser el siguiente nodo de texto después del icono
        let textNode = null;
        if (iconSpan) {
          // busca el primer textNode hermano
          let n = iconSpan.nextSibling;
          while (n && n.nodeType !== 3) n = n.nextSibling;
          textNode = n;
        }
        // Fallback: usa el contenido de wrap sin el icono
        let currentText = "";
        if (textNode) currentText = textNode.textContent.trim();
        else currentText = wrap.textContent.replace(/\s*×\s*/i, "").trim();

        if (!currentText) return;

        // Prueba en todos los scopes: el chip no expone param_name
        const h = handleize(currentText);
        const langDict = DICT[lang] || {};
        let translated = null;

        for (const scope of ["familia", "metodo", "tuestes", "molidos", "pais"]) {
          const map = langDict[scope];
          if (map && map[h]) {
            translated = map[h];
            break;
          }
        }
        if (!translated) return;

        if (textNode) {
          textNode.textContent = " " + translated;
        } else {
          // Limpia el wrap y reinyecta icono + texto
          wrap.childNodes.forEach((n) => {
            if (!(n.nodeType === 1 && n.classList.contains("m-active-facets--remove-icon"))) {
              wrap.removeChild(n);
            }
          });
          wrap.appendChild(document.createTextNode(" " + translated));
        }
      } catch (e) {}
    });
  }

  // ===== Orquestación =====
  function translateAll() {
    const lang = getLang();
    document.querySelectorAll(".m-facet--label").forEach((span) => {
      translateOneLabel(span, lang);
    });
    translateActiveChips(lang);
  }

  // Debounce para ráfagas de cambios DOM
  let t;
  function scheduleTranslate() {
    clearTimeout(t);
    t = setTimeout(translateAll, 40);
  }

  // Hooks agresivos
  document.addEventListener("DOMContentLoaded", translateAll);
  window.addEventListener("load", translateAll);
  window.addEventListener("pageshow", translateAll);
  window.addEventListener("popstate", scheduleTranslate);

  // Cambios al usar filtros (el tema suele refrescar vía AJAX)
  document.addEventListener("change", (e) => {
    const el = e.target;
    if (el && el.closest("#CollectionFiltersForm")) {
      scheduleTranslate();
      setTimeout(translateAll, 120);
      setTimeout(translateAll, 250);
      setTimeout(translateAll, 500);
    }
  });

  // Eventos típicos de temas/sections
  [
    "facets:updated",
    "collection:filters:updated",
    "collection:updated",
    "shopify:section:load",
    "shopify:section:unload",
    "shopify:section:select",
    "shopify:section:deselect",
    "shopify:block:select",
    "shopify:block:deselect",
  ].forEach((evt) => document.addEventListener(evt, scheduleTranslate));

  // Observer global: cualquier cambio en body => retraducir
  if ("MutationObserver" in window) {
    const mo = new MutationObserver(scheduleTranslate);
    mo.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  // Si el tema usa history.pushState/replaceState tras AJAX
  ["pushState", "replaceState"].forEach((m) => {
    const orig = history[m];
    history[m] = function () {
      const r = orig.apply(this, arguments);
      scheduleTranslate();
      setTimeout(translateAll, 60);
      return r;
    };
  });
})();
